import { render, staticRenderFns } from "./LeaveToPayrollPostingSetupNew.vue?vue&type=template&id=1020f6a2"
import script from "./LeaveToPayrollPostingSetupNew.vue?vue&type=script&lang=js"
export * from "./LeaveToPayrollPostingSetupNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports